import { Component, forwardRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';

@Component({
    selector: 'app-benefits-list',
    standalone: true,
    imports: [CommonModule, FormsModule],
    templateUrl: './benefits-list.component.html',
    styleUrls: ['./benefits-list.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => BenefitsListComponent),
            multi: true,
        },
    ],
})
export class BenefitsListComponent implements ControlValueAccessor {
    benefits: string[] = [];
    newBenefit = '';
    disabled = false;

    private onChange: (value: string[]) => void = () => { };
    private onTouched: () => void = () => { };

    writeValue(value: string[] | null): void {
        this.benefits = value ?? [];
    }

    registerOnChange(fn: (value: string[]) => void): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: () => void): void {
        this.onTouched = fn;
    }

    setDisabledState(isDisabled: boolean): void {
        this.disabled = isDisabled;
    }

    addBenefit(): void {
        const trimmed = this.newBenefit.trim();
        if (trimmed && !this.benefits.includes(trimmed)) {
            this.benefits = [...this.benefits, trimmed];
            this.newBenefit = '';
            this.onChange(this.benefits);
            this.onTouched();
        }
    }

    removeBenefit(index: number): void {
        this.benefits = this.benefits.filter((_, i) => i !== index);
        this.onChange(this.benefits);
        this.onTouched();
    }

    onKeydown(event: KeyboardEvent): void {
        if (event.key === 'Enter') {
            event.preventDefault();
            this.addBenefit();
        }
    }
}
